document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.finkid-eight-products .swiper', {
    // Basic settings
    slidesPerView: 1,
    spaceBetween: 0,
    
    // Enable loop
    loop: true,
    
    // Navigation arrows
    navigation: {
      nextEl: '.finkid-eight-products .swiper-button-next',
      prevEl: '.finkid-eight-products .swiper-button-prev',
    },
    
    // Scrollbar
    scrollbar: {
      el: '.finkid-eight-products .swiper-scrollbar',
      draggable: true,
      hide: false
    },
    
    // Responsive breakpoints
    breakpoints: {
      750: {
        slidesPerView: 4,
        spaceBetween: 0
      }
    }
  });
  
  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', function() {
      swiper.init();
    });
    
    document.addEventListener('shopify:section:select', function() {
      swiper.init();
    });
  }
});